import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { PRIVACY } from "@/pages/legal/_content";

const Privacy = () => <LegalPage doc={PRIVACY}><DocSections sections={PRIVACY.sections}/></LegalPage>;
export default Privacy;
